export default {
  registeredQuery: null,
  registeredHandler: null,
  register(query, callback) {
    const mediaQuery = matchMedia(query);

    callback(mediaQuery.matches);

    const handler = (event) => {
      callback(event.matches);
    };

    mediaQuery.addEventListener('change', handler);

    this.registeredQuery = mediaQuery;
    this.registeredHandler = handler;
  },
  unregister() {
    this.registeredQuery.removeEventListener('change', this.registeredHandler);
  },
};
